import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import IconButton from 'material-ui/IconButton';
import {GridList, GridTile} from 'material-ui/GridList';
import { push } from 'react-router-redux';

import { showDialog, hideDialog } from '../../actions/dialogs';
import Dashboard from '../Dashboard';

import styles from './styles';

class Admin extends Component {
  static propTypes = {
  }

  state = {
  }

  componentWillMount() {
  }

  handleJobProfiles = () => {
    this.props.push('/jobprofiles');
  }

  handlePermissions = () => {
    this.props.push('/permissions');
  }

  handleBilling = () => {
    this.props.push('/billing');
  }

  render() {
    return (
      <Dashboard>
        <GridList
          cellHeight={180}
          style={styles.gridList}
          cols={3}
        >
          <GridTile
            key="Job Profiles"
            title="Job Profiles"
            actionIcon={<IconButton
              iconClassName="material-icons"
            >
              arrow_forward
            </IconButton>}
            style={styles.button}
            onClick={()=>this.handleJobProfiles()}
          >
            <img alt="Admin" src="https://images-eu.ssl-images-amazon.com/images/G/02/uk_xsite2016/DE_PRIME_1006520_292x292_V2._CB280740925_.png" />
          </GridTile>
          <GridTile
            key="Permissions"
            title="Permissions"
            actionIcon={<IconButton
              iconClassName="material-icons"
            >
              arrow_forward
            </IconButton>}
            style={styles.button}
            onClick={()=>this.handlePermissions()}
          >
            <img alt="Admin" src="https://images-eu.ssl-images-amazon.com/images/G/02/uk_xsite2016/DE_PRIME_1006520_292x292_V2._CB280740925_.png" />
          </GridTile>
          <GridTile
            key="Billing"
            title="Billing"
            actionIcon={<IconButton
              iconClassName="material-icons"
            >
              arrow_forward
            </IconButton>}
            style={styles.button}
            onClick={()=>this.handleBilling()}
          >
            <img alt="Admin" src="https://images-eu.ssl-images-amazon.com/images/G/02/uk_xsite2016/DE_PRIME_1006520_292x292_V2._CB280740925_.png" />
          </GridTile>
        </GridList>
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    push,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin/index.js